import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Paths } from '../../../../enums';
import { CommonAPIService, CommonService, LocalStorageService, SharedService } from '../../../../services';
import { environment } from '../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-online-training-banner',
  standalone: false,
  templateUrl: './online-training-banner.component.html',
  styleUrl: './online-training-banner.component.scss'
})

export class OnlineTrainingBannerComponent implements OnInit {
  bannerList: any;
  imgURL = environment.imageURL;
  imgSRC: any;

  constructor(private router: Router,
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  async ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      await this.getBanners();
      return;
    }

    await this.loadScript('assets/js/slick.js');
    await this.getBanners();
    setTimeout(() => this.initializeCarousel(), 100);
  }

  private loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!isPlatformBrowser(this.platformId)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(`Failed to load script: ${src}`);
      document.body.appendChild(script);
    });
  }

  private initializeCarousel(): void {
    if (typeof $ === 'undefined' || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    $('.home_img_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      loop: true,
      arrows: true,
      prevArrow: '<button class="slick-arrow slick-prev"><i class="fas fa-angle-left mx-1"></i></button>',
      nextArrow: '<button class="slick-arrow slick-next"><i class="fas fa-angle-right mx-1"></i></button>'
    });
  }

  async getBanners() {
    this.sharedService.setApiCall(true);
    const response: any = await this.commonAPIService.getCall('activeBanners', '');
    this.commonService.resetAPIFlag('activeBanners', false);
    this.sharedService.setApiCall(false);
    this.bannerList = response.banners;
    const isDesktop = isPlatformBrowser(this.platformId) && typeof $ !== 'undefined' && typeof window !== 'undefined'
      ? $(window).width() > 992
      : true;

    this.bannerList = this.bannerList.map((element: any) => {
      return {
        ...element,
        // Add a new dynamic property to each individual item
        activeUrl: this.imgURL + element.imageUrl
      };
    });
  }

  getCourseCategory() {
    this.router.navigate([`${Paths.coursesCategory}`]);
  }

  ngOnDestroy(): void { }
}
